import { apiEndpoint } from '../../_config/config'
import { handleResponse } from '../../_helpers'
import axios from 'axios'
import { localForageService } from '../../_helpers/localforageService'

export const website = {
  namespaced: true,
  state: {
    website: {
      quotes: [],
      languages: [],
      pages: [],
      menus: [],
      siteName: '',
      sitePhone: '',
      siteEmail: '',
      siteAddress: '',
      logo: ''
    },
    error: {},
    currentLanguage: {
      isoCode: 'nl',
      cookieText: '',
      cookieApproveText: '',
      cookieDisapproveText: '',
      linkedInLink: '',
      facebookLink: '',
      instagramLink: '',
      youtubeLink: ''
    }
  },
  actions: {
    get ({ commit, dispatch }, { isoCode }) {
      const config = {
        method: 'GET',
        url: `${apiEndpoint}/api/frontend/website`
      }

      try {
        localForageService.getItem('website').then((saved) => {
          commit('SET_WEBSITE', saved)

          if (typeof isoCode !== 'undefined') {
            dispatch('changeCurrentLanguage', { isoCode: isoCode })
          } else {
            dispatch('changeCurrentLanguage', { isoCode: 'nl' })
          }
        })
      } catch (e) {
        console.log('Error: ', e)
      }

      axios(config).then(handleResponse)
        .then(
          response => {
            if (typeof response.result !== 'undefined') {
              const website = response.result
              commit('SET_WEBSITE', website)

              try {
                localForageService.setItem('website', website)
              } catch (e) {
                console.log('Error: ', e)
              }

              dispatch('changeCurrentLanguage', { isoCode: isoCode })
            }
          },
          error => {
            commit('SET_ERROR', error)
          }
        )
    },
    setCurrentLanguage ({ commit }, { currentLanguage }) {
      commit('SET_CURRENT_LANGUAGE', currentLanguage)
    },
    changeCurrentLanguage ({ commit, state }, { isoCode }) {
      if (state.website !== null && typeof state.website.languages !== 'undefined') {
        const newLanguage = state.website.languages.filter((l) => l.isoCode === isoCode)
        commit('SET_CURRENT_LANGUAGE', newLanguage[0])
      }
    }
  },
  mutations: {
    SET_WEBSITE (state, data) {
      state.website = data
    },
    SET_ERROR (state, error) {
      state.error = error
    },
    SET_CURRENT_LANGUAGE (state, currentLanguage) {
      state.currentLanguage = currentLanguage
    }
  },
  getters: {
    getWebsite: state => {
      return state.website
    },
    getCurrentLanguage: state => {
      return state.currentLanguage
    },
    getFooterMenuInfo: state => {
      const mItems = []

      if (state.website !== null && state.website.menus.length > 0 && typeof state.currentLanguage !== 'undefined') {
        const isoCode = state.currentLanguage.isoCode

        for (var i = 0; i < state.website.menus.length; i++) {
          const menu = state.website.menus[i]

          if (!menu.main) {
            for (var u = 0; u < menu.pages.length; u++) {
              const page = menu.pages[u]

              for (var m = 0; m < page.length; m++) {
                if (page[m].language === isoCode) {
                  mItems.push({ title: page[m].title, slug: page[m].url })
                }
              }
            }
          }
        }
      }

      return mItems
    },
    getMenuInfo: state => {
      const mItems = []

      if (state.website !== null && state.website.menus.length > 0 && typeof state.currentLanguage !== 'undefined') {
        const isoCode = state.currentLanguage.isoCode
        for (var i = 0; i < state.website.menus.length; i++) {
          const menu = state.website.menus[i]

          if (menu.main) {
            for (var u = 0; u < menu.pages.length; u++) {
              const page = menu.pages[u]

              for (var m = 0; m < page.length; m++) {
                if (page[m].language === isoCode) {
                  if (page[m].children.length === 0 && typeof page[m].children !== 'undefined') {
                    mItems.push({ title: page[m].title, slug: page[m].url, parent: page[m].parent, hasChildren: false, children: [] })
                  } else {
                    mItems.push({ title: page[m].title, slug: page[m].url, parent: page[m].parent, hasChildren: true, children: page[m].children })
                  }
                }
              }
            }
          }
        }
      }

      return mItems
    },
    getQuotesByLanguage: state => {
      if (state.website.quotes.length === 0) { return [] }
      if (typeof state.currentLanguage === 'undefined') { return [] }

      const isoCode = state.currentLanguage.isoCode
      var quotes = []

      for (var i = 0; i < state.website.quotes.length; i++) {
        var item = state.website.quotes[i]
        var quote = item.urls.filter((l) => l.language === isoCode)
        quotes.push(quote)
      }

      return quotes
    },
    hasQuotesByLanguage: state => {
      if (state.website === null || typeof state.website.quotes === 'undefined') {
        return false
      }

      return (state.website.quotes.length > 0)
    },
    getAlternativeLinks: state => (pageId) => {
      const alternatives = []

      if (state.website.pages.length > 0 && typeof state.currentLanguage !== 'undefined') {
        const isoCode = state.currentLanguage.isoCode
        const page = state.website.pages.filter((p) => p.id === pageId)
        const alternativeLinks = page[0].urls.filter((l) => l.language !== isoCode)

        for (var i = 0; i < alternativeLinks.length; i++) {
          const alt = { rel: 'alternate', hreflang: alternativeLinks[i].language, href: alternativeLinks[i].url }
          alternatives.push(alt)
        }
      }

      return alternatives
    },
    getLanguageMenu: state => (currentPath) => {
      const lItems = []

      if (typeof state.currentLanguage === 'undefined' || state.website === null) {
        return lItems
      }

      if (currentPath === '/') {
        currentPath = '/' + state.currentLanguage.isoCode + '/'
      }

      if (currentPath.length === 3) {
        currentPath += '/'
      }

      let currPage = null
      if (state.website.pages.length > 0) {
        for (var i = 0; i < state.website.pages.length; i++) {
          const page = state.website.pages[i].urls

          for (var u = 0; u < page.length; u++) {
            if (page[u].language === state.currentLanguage.isoCode && page[u].url === currentPath) {
              currPage = page
            }
          }
        }
      }

      if (state.website.languages.length > 0 && currPage !== null) {
        for (var il = 0; il < state.website.languages.length; il++) {
          const lang = state.website.languages[il]
          for (var pl = 0; pl < currPage.length; pl++) {
            if (currPage[pl].language === lang.isoCode) {
              lItems.push({ title: lang.isoCode, slug: currPage[pl].url })
            }
          }
        }
      }

      return lItems
    },
    getContactInfo: state => {
      var info = {
        siteName: '',
        sitePhone: '',
        siteEmail: '',
        siteAddress: ''
      }

      if (typeof state.website === 'undefined' || state.website === null) {
        return info
      }

      info = {
        siteName: state.website.siteName,
        sitePhone: state.website.sitePhone,
        siteEmail: state.website.siteEmail,
        siteAddress: state.website.siteAddress
      }

      return info
    },
    getLogo: state => {
      return state.website.logo
    },
    getCookieInfo: state => {
      var cookie = {
        cookieText: '',
        cookieApproveText: '',
        cookieDisapproveText: ''
      }

      if (typeof state.currentLanguage === 'undefined') {
        return cookie
      }

      cookie = {
        cookieText: state.currentLanguage.cookieText,
        cookieApproveText: state.currentLanguage.cookieApproveText,
        cookieDisapproveText: state.currentLanguage.cookieDisapproveText
      }

      return cookie
    }
  }
}
